import * as t from "io-ts";
import { MediaV } from "@/types/media";
import { DynamicFieldOutputV } from "@/types/dynamic-data";
import { OEmbedV } from "@/types/controls";

export const LinkInputValueV = t.partial({
  type: t.union([
    t.literal("url"),
    t.literal("lightbox"),
    t.literal("contact"),
    t.literal("action")
  ]),
  url: t.string,
  dynamicMeta: DynamicFieldOutputV,
  openInNewTab: t.boolean,
  html: t.partial({
    id: t.string,
    attributes: t.array(
      t.partial({
        name: t.union([t.string, t.null]),
        value: t.union([t.string, t.null])
      })
    )
  }),
  lightbox: t.partial({
    // Button Bar input returns an empty string if you click the same button twice.
    type: t.union([t.literal("image"), t.literal("video"), t.literal("")]),
    video: t.union([OEmbedV, t.string]),
    image: t.union([MediaV, t.string]),
    imageDynamicMeta: DynamicFieldOutputV,
    videoDynamicMeta: DynamicFieldOutputV,
    disableAutoplay: t.boolean
  }),
  contact: t.partial({
    type: t.union([
      t.literal("email"),
      t.literal("tel"),
      t.literal("sms"),
      t.literal("whatsapp")
    ]),
    email: t.string,
    subject: t.string,
    message: t.string,
    phoneNumber: t.string
  }),
  action: t.partial({
    type: t.union([t.literal("slider"), t.literal("popup")]),
    sliderOptions: t.partial({
      elementId: t.string,
      actionType: t.union([
        t.literal("goto"),
        t.literal("previous"),
        t.literal("next")
      ]),
      slideIndex: t.number
    }),
    popupOptions: t.partial({
      popupId: t.string,
      popupAction: t.union([
        t.literal("open"),
        t.literal("close"),
        t.literal("toggle")
      ])
    })
  })
});

export type LinkInputValue = t.TypeOf<typeof LinkInputValueV>;

export const DEFAULT_LINK_VALUE: LinkInputValue = {
  type: "url",
  url: ""
};
